import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {LANDING} from '@constants/internal-route.constant'
import {useBranding} from '@context/Branding'
import {ENV} from 'config/ENV.config'
import {KTSVG} from '_metronic/helpers'
import {useT} from 'utility/useT'
import {useLayout} from '../../core'

const SidebarLogo = () => {
  const {config} = useLayout()
  const {logoUrl} = useBranding()
  const t = useT()
  const logo = logoUrl || ENV.brandLogo
  const minimize = config.app?.sidebar?.default?.minimize?.desktop

  return (
    <div className='app-sidebar-logo px-5' id='kt_app_sidebar_logo'>
      <Link to={LANDING} className='app-sidebar-brand'>
        {/* Full lockup: company logo | app name. Minimized, only the logo shows. The display
            classes sit on inner elements because a d-flex utility (!important) would defeat the
            minimize rule that hides .app-sidebar-logo-default. */}
        <span className='app-sidebar-logo-default app-sidebar-lockup'>
          <img alt='Logo' src={logo} className='app-sidebar-brand-logo' />
          <span className='app-sidebar-brand-text'>{t('MENU.APP_NAME')}</span>
        </span>
        <img alt='Logo' src={logo} className='h-30px mw-40px app-sidebar-logo-minimize' />
      </Link>

      {minimize?.enabled && (
        <div
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            {active: minimize.default}
          )}
          data-kt-toggle='true'
          // The class Metronic toggles on the button with the sidebar; `.rotate.active` turns the
          // arrow to point right while minimized. It must always be set, not only when starting minimized.
          data-kt-toggle-state='active'
          data-kt-toggle-target='body'
          data-kt-toggle-name='app-sidebar-minimize'
          title='Collapse / expand the menu'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}
